export default __webpack_public_path__ + "assets/images/icon-link.394f8b6a300327c4ace1693f010f0c38.svg";